import * as types from './mutation-types';

import { AppState, UrlStatePayload } from '@/types';

import { ActionContext } from 'vuex';
import { DateTime } from 'luxon';
import axios from 'axios';
import { parseDirectory } from '@/support';

const DEFAULT_ERROR_RESPONSE = {
  data: 'Something went wrong!',
  status: 500,
  statusText: 'Server Error',
};

export const fetchStructure = (
  context: ActionContext<AppState, AppState>,
  payload: { path: string }
) => {
  const path = parseDirectory(payload.path);

  context.commit(types.LOADING);

  axios({
    method: 'get',
    url: `${process.env.VUE_APP_SERVICE_BASE}/api/structure`,
    params: { path, c: Number(new Date()) },
    headers: {
      accept: 'application/json',
    },
  })
    .then(({ data }) => context.commit(types.LOAD_STRUCTURE, { data }))
    .catch(error => {
      const response = error.response || DEFAULT_ERROR_RESPONSE;

      context.commit(types.SERVER_ERROR, {
        message: response.data,
        status: response.status,
        statusText: response.statusText,
      });
    });
};

export const updateStateFromUrl = (
  { commit }: ActionContext<AppState, AppState>,
  payload: UrlStatePayload
) => {
  const mapping = {
    path: { type: types.UPDATE_PATH },
    sidebar: { type: types.TOGGLE_SIDEBAR },
    lights: { type: types.TOGGLE_LIGHTS },
    time: {
      type: types.TIME_TRAVEL,
      transform: payload => ({
        sinceEpoch: payload.date,
        zone: payload.tz || DateTime.local().zoneName,
      }),
    },
  };

  Object.keys(mapping).forEach(key => {
    const mutation = mapping[key];

    if (Object.prototype.hasOwnProperty.call(payload, key)) {
      const transform = mutation.transform || (t => t);

      commit(mutation.type, transform(payload));
    }
  });
};
